import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-144" data-mp="17xkz0gyqxvhc">
      <div className="mx-auto max-w-md" data-id="element-145" data-mp="1mo22s6yusxhe">
        <h2 className="text-center text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.2rem]" data-id="element-146" data-mp="1mmzf07wtvb5p">
          <span aria-hidden="true" data-id="element-147" data-mp="1hqs400pkr9gw">🍽️ </span>Your Full Teaching Year, Ready
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-red-500 bg-white px-7 pb-8 pt-11 shadow-xl" data-id="element-148" data-mp="u0xsbmgzrqy8">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-red-500 px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-149" data-mp="p24ratiw5sey">
            Restaurant English Ready
          </span>

          <dl data-id="element-150" data-mp="2fb4yysg24w4h">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-stone-200 py-4 text-sm" data-id="element-151" data-mp="2feano6krxvzo">
                <dt className="text-stone-700" data-id="element-152" data-mp="pkh7hdqa50h9">{row.label}</dt>
                <dd className="font-bold text-red-500" data-id="element-153" data-mp="pjz3tw1afjzb">{row.value}</dd>
              </div>)}
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-red-500" data-id="element-154" data-mp="uleo3lvn5mgn">
            One-time price
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-stone-200 pb-7 pt-2" data-id="element-155" data-mp="13k9twwurwujf">
            <span className="text-6xl font-black leading-none text-red-500" data-id="element-156" data-mp="6uiqg84i7x1h">
              $27
            </span>
            <span className="self-end pb-2 text-sm font-bold text-red-500" data-id="element-157" data-mp="btlv3rgko18x">
              USD
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-stone-600" data-id="element-158" data-mp="ft4bqb1d1q5y">
            Charged in USD. Your bank may apply its own currency conversion.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-159" data-mp="3k8dnb04vmtqb" />

          <p className="mt-4 text-center text-[11px] font-medium text-stone-500" data-id="element-160" data-mp="3o9z58zw9py7d">
            Digital PDF Materials · One-Time Payment · No Subscription
          </p>

        </div>
      </div>
    </section>;
}